import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
  height?: number;
};

const Bars = styled('svg')<Props>({
  bottom: 0,
  cursor: 'pointer',
  height: '100%',
  left: 0,
  pointerEvents: 'none',
  position: 'absolute',
  width: '100%',
  [mediaQueryBuilder(mediaQueries.max.height['149'])]: {
    height: '60%',
  },
  [mediaQueryBuilder(mediaQueries.max.height['119'])]: {
    height: '40%',
  },
});

export default Bars;
